import { useState } from "react";
import { FormControl, InputLabel, OutlinedInput, Paper, Stack } from "@mui/material";
import { formatEditPageInput, validateEditPageInput, formatChannelAttributeName } from "./EditPageUtils";
import EditRowButtons from './EditRowButtons';
import ContactsEditRow from "./ContactsEditRow";


export default function EditRow({...params}){

  let channelAttributeIndex = params.channelAttributeIndex
  let channelAttributeName = params.channelAttributeName
  let oldValue = params.oldValue
  let updateNewValues = params.updateNewValues
  let updateRowErrorStates = params.updateRowErrorStates

  let [disabledState, setDisabledState] = useState(true);
  let [rowErrorState, setRowErrorState] = useState(false);
  let [inputText, setInputText] = useState("");

  if (channelAttributeName === 'channel_id') return;               //don't want option for editing channel_id directly


  function inputTextChanged(event){
    event.preventDefault()
    setInputText(event.target.value)
    if (rowErrorState === true) setRowErrorState(false)
  }


  function handleLockClick(formattedName){

    if (disabledState === true) { 
      setDisabledState(false)
      updateRowErrorStates(channelAttributeIndex, false)
      return;
    }

    else if (disabledState === false && inputText === ""){
      setDisabledState(true)
      updateRowErrorStates(channelAttributeIndex, true)
      return
    } 

    else if (disabledState === false && inputText !== "") { 

      let inputValidity = validateEditPageInput(formattedName, inputText)

      if (inputValidity === false) {
        setRowErrorState(true)
        updateRowErrorStates(channelAttributeIndex, false)
      }

      else if (inputValidity === true) {
        setDisabledState(true)
        inputText = formatEditPageInput(formattedName, inputText)
        updateNewValues(channelAttributeIndex, inputText)
        updateRowErrorStates(channelAttributeIndex, true)
      }
    }
  }


  function handleRevertClick(event){
    event.preventDefault()
    setDisabledState(true)
    setInputText("")
    setRowErrorState(false)
    updateNewValues(channelAttributeIndex, oldValue)
    updateRowErrorStates(channelAttributeIndex, true)
  }

  let formattedName = formatChannelAttributeName(channelAttributeName)

  if (formattedName === 'Station Contacts'){

    if (oldValue === undefined) oldValue = [{name: "", email: ""}]

    return (
      <ContactsEditRow 
        channelAttributeIndex={channelAttributeIndex} 
        disabledState={disabledState}
        formattedName={formattedName}
        oldValue={oldValue} 
        rowErrorState={rowErrorState} 
        setDisabledState={setDisabledState}
        setRowErrorState={setRowErrorState}
        updateNewValues={updateNewValues}
        updateRowErrorStates={updateRowErrorStates}
      />
    )
  }

  else {
    return (
      <Paper sx={{padding: "0.25em", paddingBottom: "0.5em", marginBottom: "0.75em"}} className={"EditRowPaper"}>

        <Stack direction={"row"} width={"100%"}>
          <FormControl sx={{paddingTop: '1vh', marginTop: '1em'}}>
            <InputLabel htmlFor="component-outlined" shrink={true} sx={{color: 'var(--mui-palette-common-onBackground)'}}>{formattedName}</InputLabel>
            
            <OutlinedInput
              label={formattedName}
              placeholder={formatEditPageInput("", oldValue)}
              onChange={inputTextChanged}
              disabled={disabledState}
              value={inputText}
              error={rowErrorState}
            />
          </FormControl>

          <EditRowButtons 
            formattedName={formattedName} 
            errorState={rowErrorState} 
            disabledState={disabledState} 
            handleLockClick={handleLockClick} 
            handleRevertClick={handleRevertClick} 
          />
        </Stack>
      </Paper>
    )
  }
}
